import React from 'react';
import MetaAdsDetails from '../components/MetaAdsDetails';

const MetaAdsDetailsApp = (props) => <MetaAdsDetails {...props} />;

export default MetaAdsDetailsApp;
